import Seo from '../components/Seo';

export default function Contact() {

  return (
    <div className="min-h-screen bg-gray-50 py-16 px-4">
      <Seo
        title="Contact Bezy Driving School | DVSA Approved Instructor"
        description="Contact Bezy Driving School to book automatic driving lessons in Erith, Belvedere and nearby areas. Learn with a DVSA Approved Instructor."
        path="/contact"
      />
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-5xl font-bold text-gray-900 mb-4">
            Contact Bezy Driving School
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Ready to book your lessons? Get in touch to discuss area coverage, pricing options, and your goals with our DVSA Approved Instructor.
          </p>
        </div>

        {/* WhatsApp Section */}
        <div className="bg-green-50 border-2 border-green-600 rounded-lg p-8 text-center mb-16">
          <div className="text-5xl mb-4">💬</div>
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Message us on WhatsApp
          </h2>
          <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
            Quick and easy - message us on WhatsApp for instant replies during business hours.
          </p>
          <a
            href="https://wa.me/447449975074?text=Hello%2C%20I%20am%20interested%20in%20booking%20driving%20lessons%20with%20Bezy%20Driving%20School.%20Could%20you%20please%20provide%20information%20about%20availability%20and%20next%20steps%3F"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-8 rounded-lg transition inline-block"
          >
            💬 Chat on WhatsApp
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {/* Contact Information */}
          {[
            {
              icon: "📧",
              title: "Email",
              content: "bezydrivingschool@gmail.com",
              subtext: "We typically respond within 24 hours"
            },
            {
              icon: "📱",
              title: "Phone",
              content: "+44 7449 975074",
              subtext: "We typically respond within 24 hours"
            }
          ].map((contact, index) => (
            <div key={index} className="bg-white rounded-lg shadow-lg p-8 text-center">
              <div className="text-4xl mb-4">{contact.icon}</div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">
                {contact.title}
              </h3>
              {contact.title === "Phone" ? (
                <a
                  href={`sms:${contact.content.replace(/\s/g, '')}`}
                  className="text-lg text-blue-600 hover:text-blue-700 font-semibold mb-2 block"
                >
                  {contact.content}
                </a>
              ) : contact.title === "Email" ? (
                <a
                  href={`mailto:${contact.content}`}
                  className="text-lg text-blue-600 hover:text-blue-700 font-semibold mb-2 block"
                >
                  {contact.content}
                </a>
              ) : (
                <p className="text-lg text-gray-600 mb-2">
                  {contact.content}
                </p>
              )}
              <p className="text-sm text-gray-500">
                {contact.subtext}
              </p>
            </div>
          ))}
        </div>

        {/* Social Media Section */}
        <div className="bg-pink-50 border-2 border-pink-600 rounded-lg p-8 text-center">
          <div className="text-5xl mb-4">📱</div>
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Follow us on Social Media
          </h2>
          <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
            Follow Bezy Driving School for driving tips, student success stories, and special offers.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-3">
            <a
              href="https://www.instagram.com/bezydrivingschool/"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-pink-600 hover:bg-pink-700 text-white font-bold py-3 px-6 rounded-lg transition inline-flex items-center justify-center gap-2"
            >
              <svg aria-hidden="true" viewBox="0 0 24 24" className="h-5 w-5 fill-current">
                <path d="M7.75 2h8.5A5.75 5.75 0 0 1 22 7.75v8.5A5.75 5.75 0 0 1 16.25 22h-8.5A5.75 5.75 0 0 1 2 16.25v-8.5A5.75 5.75 0 0 1 7.75 2Zm0 1.5A4.25 4.25 0 0 0 3.5 7.75v8.5A4.25 4.25 0 0 0 7.75 20.5h8.5a4.25 4.25 0 0 0 4.25-4.25v-8.5A4.25 4.25 0 0 0 16.25 3.5h-8.5Zm8.88 1.12a1.13 1.13 0 1 1 0 2.26 1.13 1.13 0 0 1 0-2.26ZM12 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10Zm0 1.5A3.5 3.5 0 1 0 12 15.5 3.5 3.5 0 0 0 12 8.5Z" />
              </svg>
              <span>Follow on Instagram</span>
            </a>
            <a
              href="https://www.facebook.com/share/1EhKRYtVEK/?mibextid=wwXIfr"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-lg transition inline-flex items-center justify-center gap-2"
            >
              <svg aria-hidden="true" viewBox="0 0 24 24" className="h-5 w-5 fill-current">
                <path d="M13.5 22v-8h2.7l.4-3h-3.1V9.1c0-.87.24-1.46 1.5-1.46H16.7V4.96c-.3-.04-1.3-.12-2.46-.12-2.44 0-4.11 1.49-4.11 4.23V11H7.4v3h2.73v8h3.37Z" />
              </svg>
              <span>Follow on Facebook</span>
            </a>
            <a
              href="https://www.tiktok.com/@bezydrivingschool?_r=1&_t=ZN-95ERCwIzM5G"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-gray-900 hover:bg-black text-white font-bold py-3 px-6 rounded-lg transition inline-flex items-center justify-center gap-2"
            >
              <svg aria-hidden="true" viewBox="0 0 24 24" className="h-5 w-5 fill-current">
                <path d="M14.5 3c.42 1.86 1.53 3.27 3.5 3.7V9a6.2 6.2 0 0 1-3.5-1.08v6.58A5.5 5.5 0 1 1 9 9c.25 0 .5.02.75.06v2.54A3 3 0 1 0 12 14.5V3h2.5Z" />
              </svg>
              <span>Follow on TikTok</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
